import { render } from "./newsDetail.vue?vue&type=template&id=4c74dd4b&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"

import "./newsDetail.vue?vue&type=style&index=0&id=4c74dd4b&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c74dd4b"]])

export default __exports__